<template>
  <SwitchRoot
    :id="id"
    v-model="value"
    :aria-label="ariaLabel"
    class="relative w-11 h-6 rounded-full"
    :class="[value ? 'bg-fill-brand' : 'bg-fill-disabled']"
  >
    <SwitchThumb
      class="block w-[21px] h-[21px] my-auto shadow-sm rounded-full bg-icon-on_branded_surface transition-transform duration-100 translate-x-0.5 will-change-transform data-[state=checked]:translate-x-[19px]"
    />
  </SwitchRoot>
</template>

<script setup lang="ts">
import { SwitchRoot, SwitchThumb } from "reka-ui";

defineProps<{
  id: string;
  ariaLabel?: string;
}>();

const value = defineModel<boolean>({ required: true });
</script>
